import React, { createRef } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { Divider } from '@material-ui/core'
import config from "../../config/config"
import axios from 'axios'
import {styles} from '../CSS/Styles'
import Button from '@material-ui/core/Button'
import RiskInformation from './RiskRegisterSection/A'
import RiskRating from './RiskRegisterSection/B'
import RiskDriverConsequence from './RiskRegisterSection/C'
import Controls from './RiskRegisterSection/D'
import ActionPlan from './RiskRegisterSection/E'
import KRI from './RiskRegisterSection/F'
import RiskTolerance from './RiskRegisterSection/G'
import * as helper from './helper/Datahelper'

const Grouplist = ['', '', '']

class RecipeReviewCard extends React.Component {


    constructor(props) {

        super(props)
        this.risk_info_temp = {}
        this.control_info_temp = {}
        this.action_info_temp = {}
        this.owner_info_temp = {}
        this.kri_threshold_info_temp = {}
        this.risk_tolerance_info_temp = {}

        let riskprops = this.props.risk
        let data = helper.extractelement(this.props.risk)

        this.risk_info_temp = data.risk_info_temp
        this.control_info_temp = data.control_info_temp
        this.action_info_temp = data.action_info_temp
        this.owner_info_temp = data.owner_info_temp
        this.kri_threshold_info_temp = data.kri_threshold_info_temp
        this.risk_tolerance_info_temp = data.risk_tolerance_info_temp

        //console.log(riskprops)
        this.state = {
            'RiskDescription': riskprops.risk_description,
            'RiskAppetiteStatement': riskprops.risk_appetite_statements,
            'Strategic': riskprops.strategic,
            'Operational': riskprops.operational,
            'Compliance': riskprops.compliance,
            'Financial': riskprops.financial,
            'Technology': riskprops.technology,
            'NETS Entity': riskprops.NETS,
            'BCS Entity': riskprops.BCS,
            'BCSIS Entity': riskprops.BCSIS,
            'No': riskprops.no_appetite,
            'V. Low': riskprops.very_low_appetite,
            'Low': riskprops.low_appetite,
            'Medium': riskprops.medium_appetite,
            'High': riskprops.high_appetite,

            'filter': [],

            'driver': riskprops.risk_driver,
            'consequence': riskprops.risk_consequence,

            //'GrossLike': riskprops.gross_likelhood,
            //'GrossImpact': riskprops.gross_impact,
            'ResidualLike': riskprops.residual_likelhood,
            'ResidualImpact': riskprops.residual_impact,
            'TargetLike': riskprops.target_likelhood,
            'TargetImpact': riskprops.target_impact,
            //'GrossRating': riskprops.gross_rating,
            'ResidualRating': riskprops.residual_rating,
            'TargetRating': riskprops.target_rating,

            'AppetiteToleranceCheckBox': [],
            'Risk Owners': this.owner_info_temp['Risk Owners'],
            'Supported by': this.owner_info_temp['Supported by'],

            'control': this.control_info_temp.control,
            'ControlNo': this.control_info_temp.ControlNo,
            'ControlDescription': this.control_info_temp.ControlDescription,
            'ControlOwner': this.control_info_temp.ControlOwner,
            'ControlFrequency': this.control_info_temp.ControlFrequency,
            'ControlNETS': this.control_info_temp.ControlNETS,
            'ControlBCS': this.control_info_temp.ControlBCS,
            'ControlBCSIS': this.control_info_temp.ControlBCSIS,
            'ControlStrength': this.control_info_temp.ControlStrength,
            'ControlRCSA': this.control_info_temp.ControlRCSA,
            'ControlIA': this.control_info_temp.ControlIA,
            'ControlOthers': this.control_info_temp.ControlOthers,

            'action': this.action_info_temp.actions,
            'ActionPlanNo': this.action_info_temp.ActionPlanNo,
            'ActionPlanDescription': this.action_info_temp.ActionPlanDescription,
            'ActionOwner': this.action_info_temp.ActionOwner,
            'ActionType': this.action_info_temp.ActionType,
            'ControlRef': this.action_info_temp.ControlRef,
            'implementationStatus': this.action_info_temp.implementationStatus,
            'actionTimeline': this.action_info_temp.actionTimeline,
            
            'kri': this.kri_threshold_info_temp.kris,
            'kriNo': this.kri_threshold_info_temp.kriNo,
            'kriDescription': this.kri_threshold_info_temp.kriDescription,
            'kriOwner': this.kri_threshold_info_temp.kriOwner,
            'kriFrequency': this.kri_threshold_info_temp.kriFrequency,
            'kriLeftBound': this.kri_threshold_info_temp.kriLeftBound,
            'kriRightBound': this.kri_threshold_info_temp.kriRightBound,

            'riskTolerance': this.risk_tolerance_info_temp.riskTolerances,
            'riskToleranceNo': this.risk_tolerance_info_temp.riskToleranceNo,
            'riskToleranceDescription': this.risk_tolerance_info_temp.riskToleranceDescription,
            'riskToleranceOwner': this.risk_tolerance_info_temp.riskToleranceOwner,
            'riskTolerancevalue': this.risk_tolerance_info_temp.riskTolerancevalue
        }
        this.Risk_info_temp = this.state
    }

    getFilter() {
        let filterData = {
            'Applicable Entities: ': ['ABC Entity', 'ABB Entity', 'ACC Entity'],
            'Risk Category: ': ['Strategic', 'Operational', 'Compliance', 'Financial', 'Technology']
        }
        this.setState( { filter: filterData } )

        let AppetiteTolerancefilterData = {
            '': ['No', 'V. Low', 'Low', 'Medium', 'High']
        }
        this.setState( { AppetiteToleranceCheckBox: AppetiteTolerancefilterData } )
    }

    componentWillMount() {
        this.getFilter()
    }

    componentDidMount() {

    }

    componentWillUpdate(prevProps) {

    }

    componentDidUpdate(prevProps) {
        // console.log("new id : " + this.props.queryID + "vs old id : " + prevProps.queryID);
        if (this.props !== prevProps) {
            let riskprops = this.props.risk
            let data = helper.extractelement(this.props.risk)
    
    
            this.risk_info_temp = data.risk_info_temp
            this.control_info_temp = data.control_info_temp
            this.action_info_temp = data.action_info_temp
            this.owner_info_temp = data.owner_info_temp
            this.kri_threshold_info_temp = data.kri_threshold_info_temp
            this.risk_tolerance_info_temp = data.risk_tolerance_info_temp


            console.log(this.owner_info_temp)

            this.setState({
                'RiskDescription': riskprops.risk_description,
                'RiskAppetiteStatement': riskprops.risk_appetite_statements,
                'Strategic': riskprops.strategic,
                'Operational': riskprops.operational,
                'Compliance': riskprops.compliance,
                'Financial': riskprops.financial,
                'Technology': riskprops.technology,
                'NETS Entity': riskprops.NETS,
                'BCS Entity': riskprops.BCS,
                'BCSIS Entity': riskprops.BCSIS,
                'No': riskprops.no_appetite,
                'V. Low': riskprops.very_low_appetite,
                'Low': riskprops.low_appetite,
                'Medium': riskprops.medium_appetite,
                'High': riskprops.high_appetite,
    
                'driver': riskprops.risk_driver,
                'consequence': riskprops.risk_consequence,
    
                //'GrossLike': riskprops.gross_likelhood,
                //'GrossImpact': riskprops.gross_impact,
                'ResidualLike': riskprops.residual_likelhood,
                'ResidualImpact': riskprops.residual_impact,
                'TargetLike': riskprops.target_likelhood,
                'TargetImpact': riskprops.target_impact,
                //'GrossRating': riskprops.gross_rating,
                'ResidualRating': riskprops.residual_rating,
                'TargetRating': riskprops.target_rating,
    
                'AppetiteToleranceCheckBox': [],
                'Risk Owners': this.owner_info_temp['Risk Owners'],
                'Supported by': this.owner_info_temp['Supported by'],
    
                'control': this.control_info_temp.control,
                'ControlNo': this.control_info_temp.ControlNo,
                'ControlDescription': this.control_info_temp.ControlDescription,
                'ControlOwner': this.control_info_temp.ControlOwner,
                'ControlFrequency': this.control_info_temp.ControlFrequency,
                'ControlNETS': this.control_info_temp.ControlNETS,
                'ControlBCS': this.control_info_temp.ControlBCS,
                'ControlBCSIS': this.control_info_temp.ControlBCSIS,
                'ControlStrength': this.control_info_temp.ControlStrength,
                'ControlRCSA': this.control_info_temp.ControlRCSA,
                'ControlIA': this.control_info_temp.ControlIA,
                'ControlOthers': this.control_info_temp.ControlOthers,
    
                'action': this.action_info_temp.actions,
                'ActionPlanNo': this.action_info_temp.ActionPlanNo,
                'ActionPlanDescription': this.action_info_temp.ActionPlanDescription,
                'ActionOwner': this.action_info_temp.ActionOwner,
                'ActionType': this.action_info_temp.ActionType,
                'ControlRef': this.action_info_temp.ControlRef,
                'implementationStatus': this.action_info_temp.implementationStatus,
                'actionTimeline': this.action_info_temp.actionTimeline,
                
                'kri': this.kri_threshold_info_temp.kris,
                'kriNo': this.kri_threshold_info_temp.kriNo,
                'kriDescription': this.kri_threshold_info_temp.kriDescription,
                'kriOwner': this.kri_threshold_info_temp.kriOwner,
                'kriFrequency': this.kri_threshold_info_temp.kriFrequency,
                'kriLeftBound': this.kri_threshold_info_temp.kriLeftBound,
                'kriRightBound': this.kri_threshold_info_temp.kriRightBound,
    
                'riskTolerance': this.risk_tolerance_info_temp.riskTolerances,
                'riskToleranceNo': this.risk_tolerance_info_temp.riskToleranceNo,
                'riskToleranceDescription': this.risk_tolerance_info_temp.riskToleranceDescription,
                'riskToleranceOwner': this.risk_tolerance_info_temp.riskToleranceOwner,
                'riskTolerancevalue': this.risk_tolerance_info_temp.riskTolerancevalue
            })
        }
    }

    riskData(Riskname) {
        let RiskData = {
            risk_name: Riskname,
            strategic: this.risk_info_temp.Strategic,
            operational: this.risk_info_temp.Operational,
            compliance: this.risk_info_temp.Compliance,
            financial: this.risk_info_temp.Financial,
            technology: this.risk_info_temp.Technology,
            risk_description: this.risk_info_temp.RiskDescription,
            NETS: this.risk_info_temp['NETS Entity'],
            BCS: this.risk_info_temp['BCS Entity'],
            BCSIS: this.risk_info_temp['BCSIS Entity'],
            no_appetite: this.risk_info_temp['No'],
            very_low_appetite: this.risk_info_temp['V. Low'],
            low_appetite: this.risk_info_temp['Low'],
            medium_appetite: this.risk_info_temp['Medium'],
            high_appetite: this.risk_info_temp['High'],
            risk_appetite_statements: this.risk_info_temp.RiskAppetiteStatement,
            residual_likelhood: this.risk_info_temp.ResidualLike,
            residual_impact: this.risk_info_temp.ResidualImpact,
            residual_rating: this.risk_info_temp.ResidualRating,
            target_likelhood: this.risk_info_temp.TargetLike,
            target_impact: this.risk_info_temp.TargetImpact,
            target_rating: this.risk_info_temp.TargetRating,
            gross_likelhood: this.risk_info_temp.GrossLike,
            gross_impact: this.risk_info_temp.GrossImpact,
            gross_rating: this.risk_info_temp.GrossRating,
            risk_driver: this.risk_info_temp.driver,
            risk_consequence: this.risk_info_temp.consequence
            // tier_level, current, update_itme, upload_by is handled at BE.
        }
        console.log(RiskData)
        console.log("risk appetite statement")
        console.log(RiskData.risk_appetite_statements)
        return (RiskData)
    }

    actionData(Riskname) {
        let ActionData = []
        for (let i = 0; i < this.action_info_temp.ActionPlanNo.length; i++) {

            let ActionDataitem = {
                risk_name: Riskname,
                action_plans_no: this.action_info_temp.ActionPlanNo[i],
                summary_of_action_plans: this.action_info_temp.ActionPlanDescription[i],
                action_plans_owner: this.action_info_temp.ActionOwner[i],
                action_type: this.action_info_temp.ActionType[i],
                control_reference: this.action_info_temp.ControlRef[i],
                implementation_status: this.action_info_temp.implementationStatus[i],
                timeline: this.action_info_temp.actionTimeline[i]
                // risk_id is handled at BE.
            }
            ActionData.push(ActionDataitem)
        }
        console.log(ActionData)
        return (ActionData)
    }


    controlData(Riskname) {
        let ControlData = []
        for (let i = 0; i < this.control_info_temp.ControlNo.length; i++) {

            let ControlDataitem = {
                risk_name: Riskname,
                control_no: this.control_info_temp.ControlNo[i],
                summary_of_controls: this.control_info_temp.ControlDescription[i],
                control_owner: this.control_info_temp.ControlOwner[i],
                frequency: this.control_info_temp.ControlFrequency[i],
                NETS: this.control_info_temp.ControlNETS[i],
                BCS: this.control_info_temp.ControlBCS[i],
                BCSIS: this.control_info_temp.ControlBCSIS[i],
                control_strength: this.control_info_temp.ControlStrength[i],
                RCSA: this.control_info_temp.ControlRCSA[i],
                IA: this.control_info_temp.ControlIA[i],
                others: this.control_info_temp.ControlOthers[i]
                // risk_id is handled at BE.
            }
            ControlData.push(ControlDataitem)
        }
        console.log(ControlData)
        return (ControlData)
    }

    ownerData(Riskname) {
        let ownerData = []

        for (let index in this.owner_info_temp['Risk Owners']) {
            let item = this.owner_info_temp['Risk Owners'][index]
            console.log(item)
            // if it is a string => it has been modified
            let Leaderemployeeitem={}
            if ( item.risk_owners == null) {
                let LeaderEmployeeName = item.split(', ')[0]
                let LeaderEmployeeDesignation = item.split(', ')[1]
                Leaderemployeeitem = this.props.employee.find((employee) => {return(employee.name==LeaderEmployeeName && employee.designation == LeaderEmployeeDesignation)})
            } else {
                Leaderemployeeitem = item
            }
            console.log(Leaderemployeeitem)
            let leader = {
                risk_name: Riskname,
                risk_owners: Leaderemployeeitem.name == null ? Leaderemployeeitem.risk_owners : Leaderemployeeitem.name,
                staff_id: Leaderemployeeitem.staff_id,
                risk_lead: "Yes",
                ref_short_designation: Leaderemployeeitem.short_designation == null ? Leaderemployeeitem.ref_short_designation : Leaderemployeeitem.short_designation,
                risk_owners_designation: Leaderemployeeitem.designation == null ? Leaderemployeeitem.risk_owners_designation : Leaderemployeeitem.designation
                // risk_id is handled at BE.
            }
            ownerData.push(leader)
        }

        for (let index in this.owner_info_temp['Supported by']) {
            let item = this.owner_info_temp['Supported by'][index]
            console.log(item)
                        // if it is a string => it has been modified
            let Supportoremployeeitem={}
            if ( item.risk_owners == null) {
                let SupportorEmployeeName = item.split(', ')[0]
                let SupportorEmployeeDesignation = item.split(', ')[1]
                Supportoremployeeitem = this.props.employee.find((employee) => {return(employee.name==SupportorEmployeeName && employee.designation == SupportorEmployeeDesignation)})
            } else {
                Supportoremployeeitem = item
            }
            console.log(Supportoremployeeitem)
            let supportor = {
                risk_name: Riskname,
                risk_owners: Supportoremployeeitem.name == null ? Supportoremployeeitem.risk_owners : Supportoremployeeitem.name,
                staff_id: Supportoremployeeitem.staff_id,
                risk_lead: null,
                ref_short_designation: Supportoremployeeitem.short_designation == null ? Supportoremployeeitem.ref_short_designation : Supportoremployeeitem.short_designation,
                risk_owners_designation: Supportoremployeeitem.designation == null ? Supportoremployeeitem.risk_owners_designation : Supportoremployeeitem.designation
                // risk_id is handled at BE.
            }
            ownerData.push(supportor)
        }
        console.log(ownerData)
        return (ownerData)
    }

    kriThresholdsData(Riskname) {
        let KriThresholdsData = []
        console.log(this.kri_threshold_info_temp)
        for (let i = 0; i < this.kri_threshold_info_temp.kriNo.length; i++) {

            let KriThresholdsDataitem = {
                risk_name: Riskname,
                kri_id: this.kri_threshold_info_temp.kriNo[i],
                kri_description: this.kri_threshold_info_temp.kriDescription[i],
                kri_owner: this.kri_threshold_info_temp.kriOwner[i],
                frequency: this.kri_threshold_info_temp.kriFrequency[i],
                kri_left_bound: this.kri_threshold_info_temp.kriLeftBound[i],
                kri_right_bound: this.kri_threshold_info_temp.kriRightBound[i],
                // risk_id is handled at BE.
            }
            KriThresholdsData.push(KriThresholdsDataitem)
        }
        console.log(KriThresholdsData)
        return (KriThresholdsData)
    }


    riskToleranceData(Riskname) {
        let riskToleranceData = []
        for (let i = 0; i < this.risk_tolerance_info_temp.riskToleranceNo.length; i++) {
            let riskToleranceDataitem = {
                risk_name: Riskname,
                risk_tolerance_id: this.risk_tolerance_info_temp.riskToleranceNo[i],
                risk_tolerance_description: this.risk_tolerance_info_temp.riskToleranceDescription[i],
                risk_tolerance_owner: this.risk_tolerance_info_temp.riskToleranceOwner[i],
                risk_tolerance_tolerance: this.risk_tolerance_info_temp.riskTolerancevalue[i]
                // risk_id is handled at BE.
            }
            riskToleranceData.push(riskToleranceDataitem)
        }
        console.log(riskToleranceData)
        return (riskToleranceData)
    }

    handleFormSubmit = (Riskname) => {

        let RiskPayload = this.riskData(Riskname)
        let APPayload = this.actionData(Riskname)
        let ControlPayload = this.controlData(Riskname)
        let OwnerPayload = this.ownerData(Riskname)
        let KriThresholdsPayload = this.kriThresholdsData(Riskname)
        let riskTolerancePayload = this.riskToleranceData(Riskname)

        let APPayloadfinish = false
        let ControlPayloadfinish = false
        let OwnerPayloadfinish = false
        let KriThresholdsPayloadfinish = false
        let riskTolerancePayloadfinish = false
        
        axios.post(config.risk + Riskname, RiskPayload, Riskname)
            .then(res=>{
                console.log("alert sub")
                console.log(res)
//
                // need to insert risk first or it may not be able to find the foreign key link to risk
                // submit Action Plan
                
                axios.post(config.AP + Riskname, APPayload, Riskname)
                    .then(APres=>{
                        console.log("AP sub")
                        console.log(APres)
                        APPayloadfinish = true
                        // if everything upload finish
                        if (APPayloadfinish && ControlPayloadfinish && OwnerPayloadfinish && KriThresholdsPayloadfinish && riskTolerancePayloadfinish) {
                            window.location.reload()
                        }
                    })
                    .catch(error=> {
                        console.log(error.response)
                    })
//
                // submit Control
                axios.post(config.controls + Riskname, ControlPayload, Riskname)
                    .then(Controlres=>{
                        console.log("control sub")
                        console.log(Controlres)
                        ControlPayloadfinish = true
                        // if everything upload finish
                        if (APPayloadfinish && ControlPayloadfinish && OwnerPayloadfinish && KriThresholdsPayloadfinish && riskTolerancePayloadfinish) {
                            window.location.reload()
                        }
                    })
                    .catch(error=> {
                        console.log(error.response)
                    })
//
//
                // submit Owner
                
                //console.log(OwnerPayload)
                axios.post(config.owners + Riskname, OwnerPayload, Riskname)
                    .then(Ownerres=>{
                        console.log("owner sub")
                        console.log(Ownerres)
                        OwnerPayloadfinish = true
                        // if everything upload finish
                        if (APPayloadfinish && ControlPayloadfinish && OwnerPayloadfinish && KriThresholdsPayloadfinish && riskTolerancePayloadfinish) {
                            window.location.reload()
                        }
                    })
                    .catch(error=> {
                        console.log(error.response)
                    })
//
                // submit Owner
                
                //console.log(OwnerPayload)
                axios.post(config.KriThresholds + Riskname, KriThresholdsPayload, Riskname)
                    .then(KriThresholdsres=>{
                        console.log("KriThresholdsPayload sub")
                        console.log(KriThresholdsres)
                        KriThresholdsPayloadfinish = true
                        // if everything upload finish
                        if (APPayloadfinish && ControlPayloadfinish && OwnerPayloadfinish && KriThresholdsPayloadfinish && riskTolerancePayloadfinish) {
                            window.location.reload()
                        }
                    })
                    .catch(error=> {
                        console.log(error.response)
                    })

                axios.post(config.risktolerances + Riskname, riskTolerancePayload, Riskname)
                    .then(risktolerancesres=>{
                        console.log("riskTolerancePayload sub")
                        console.log(risktolerancesres)
                        riskTolerancePayloadfinish = true
                        // if everything upload finish
                        if (APPayloadfinish && ControlPayloadfinish && OwnerPayloadfinish && KriThresholdsPayloadfinish && riskTolerancePayloadfinish) {
                            window.location.reload()
                        }
                    })
                    .catch(error=> {
                        console.log(error.response)
                    })

            })
            .catch(error=> { 
                console.log(error)
            })


    };

    handleFormRestore = () => {
        console.log("restore form")
    };


    handleRiskInformationChildUpdate = (key, value) =>{
        this.risk_info_temp[key] = value
        //console.log(this.risk_info_temp)
    }

    handleOwnerChildUpdate = (key, value) =>{
        this.owner_info_temp[key] = value
        //console.log(this.owner_info_temp)
    }

    handleControlChildUpdate = (key, value) =>{
        this.control_info_temp[key] = value
        //console.log(this.control_info_temp)
    }

    handleActionChildUpdate = (key, value) =>{
        this.action_info_temp[key] = value
        //console.log(this.action_info_temp)
    }

    handleKRIChildUpdate = (key, value) =>{
        console.log(key+', '+value)
        this.kri_threshold_info_temp[key] = value
        console.log(this.kri_threshold_info_temp)
    }

    handleToleranceChildUpdate = (key, value) =>{
        this.risk_tolerance_info_temp[key] = value
        //console.log(this.risk_tolerance_info_temp)
    }

    render() {
        let namelist = []
        for (let list in this.props.employee) {
            namelist.push(this.props.employee[list].name + ', ' + this.props.employee[list].designation)
        }

        const reflist = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
        const refList = []
        reflist.map((value, index)=>{ refList.push(createRef()) })
        const naviHandler = ((id)=>{
            if (refList[id].current) {
                refList[id].current.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                })
            }
        })

        //console.log("hello in formdetail")
        //console.log(this.state.tasksdata)
        // console.log("in list detail render")
        // console.log(this.state.metaData)
        // console.log("the queryID of this listdetail is "+ this.props.queryID)
        // console.log("render with data ");
        // console.log(this.state.data);
        // console.log("data username : "+ this.state.metaData.owner_name+"    props username : "+ this.props.username)
        const { classes } = this.props;
        // console.log("pending tasks : "+ this.state.tasksdata)
        const testEmails = ["yongyibian@kpmg.com", "elisa@kpmg.com", "yuri@kpmg.com", "jiajie@kpmg.com", "koonhan@kpmg.com"]

        const options = this.state.listOfAssignee ? this.state.listOfAssignee.map(user=>({
            value: user.username,
            label: user.username
        })) : undefined


        const inputForm = (
            <div style={{height:"100%"}}>
                <div className={classes.FormNavi}>
                    <Typography variant = "h6"  align="left" className={classes.FormHeader}> {this.props.riskname} </Typography>
                    <Divider className={classes.FormDivider}/>

                    <Button className={classes.FormDirectoryBotton} size = "small" variant = "outlined" onClick={()=>{naviHandler(0)}}> A. Risk Information </Button>
                    <Button className={classes.FormDirectoryBotton} size = "small" variant = "outlined" onClick={()=>{naviHandler(1)}}> B. Risk Rating </Button>
                    <Button className={classes.FormDirectoryBotton} size = "small" variant = "outlined" onClick={()=>{naviHandler(2)}}> C. Drivers & Consequences </Button>
                    <Button className={classes.FormDirectoryBotton} size = "small" variant = "outlined" onClick={()=>{naviHandler(3)}}> D. Existing Controls </Button>
                    <Button className={classes.FormDirectoryBotton} size = "small" variant = "outlined" onClick={()=>{naviHandler(4)}}> E. Additional Action Plans </Button>
                    <Button className={classes.FormDirectoryBotton} size = "small" variant = "outlined" onClick={()=>{naviHandler(5)}}> F. Key Risk Indicators </Button>
                    <Button className={classes.FormDirectoryBotton} size = "small" variant = "outlined" onClick={()=>{naviHandler(6)}}> G. Risk Appetite and Tolerance </Button>
                </div>
                <form className={classes.inputForm}>
                    <div ref = {refList[0]} >
                        <RiskInformation 
                            riskname={this.props.riskname}
                            namelist={namelist} 
                            filter={this.state.filter} 
                            riskOwner={{'Risk Owners': this.state['Risk Owners'], 'Supported by': this.state['Supported by']}} 
                            submitChange={this.handleRiskInformationChildUpdate}
                            submitOwnerChange={this.handleOwnerChildUpdate}
                            RiskDescription={this.state.RiskDescription}
                            Strategic = {this.state.Strategic}
                            Operational = {this.state.Operational}
                            Compliance = {this.state.Compliance}
                            Financial = {this.state.Financial}
                            Technology = {this.state.Technology}
                            ABCEntity = {this.state['NETS Entity']}
                            ABBEntity = {this.state['BCS Entity']}
                            ACCEntity = {this.state['BCSIS Entity']}
                        />
                    </div>
    

                    <div ref = {refList[1]} >
                        <RiskRating
                            riskname={this.props.riskname}
                            ResidualLike = {this.state.ResidualLike}
                            ResidualImpact = {this.state.ResidualImpact}
                            ResidualRating = {this.state.ResidualRating}
                            TargetLike = {this.state.TargetLike}
                            TargetImpact = {this.state.TargetImpact}
                            TargetRating = {this.state.TargetRating}
                            //GrossLike = {this.state.GrossLike}
                            //GrossImpact = {this.state.GrossImpact}
                            //GrossRating = {this.state.GrossRating}
                            submitChange={this.handleRiskInformationChildUpdate}
                        />
                    </div>

                    <div ref = {refList[2]} >
                        <RiskDriverConsequence
                            riskname={this.props.riskname}
                            driver={this.state.driver}
                            consequence={this.state.consequence}
                            submitChange={this.handleRiskInformationChildUpdate}
                        />
                    </div>
    

                    <div ref = {refList[3]} >
                        {this.state.control == null ? null : 
                            <Controls
                                submitChange={this.handleControlChildUpdate}
                                riskname={this.props.riskname}
                                control = {this.state.control}
                                employee={this.props.employee}
                            />
                        }
                    </div>


                    <div ref = {refList[4]} >
                        {this.state.action == null ? null : 
                            <ActionPlan
                                submitChange={this.handleActionChildUpdate}
                                riskname={this.props.riskname}
                                employee={this.props.employee}
                                action= {this.state.action}
                            />
                        }
                    </div>

                    <div ref = {refList[5]} >
                        <KRI
                            submitChange={this.handleKRIChildUpdate}
                            riskname={this.props.riskname}
                            employee={this.props.employee}
                            kri={this.state.kri}
                        />
                    </div>

                    <div ref = {refList[6]} >
                        <RiskTolerance
                            submitChange={this.handleToleranceChildUpdate}
                            submitRiskChange={this.handleRiskInformationChildUpdate}
                            riskname={this.props.riskname}
                            employee={this.props.employee}
                            No = {this.state['No']}
                            VLow= {this.state['V. Low']}
                            Low= {this.state['Low']}
                            Medium= {this.state['Medium']}
                            High= {this.state['High']}
                            RiskAppetiteStatement = {this.state.RiskAppetiteStatement}
                            riskTolerance = {this.state.riskTolerance}
                        />
                    </div>

                    <Divider className={classes.FormDivider}/>



                    <Button variant="outlined" color="primary" className={classes.button} onClick= {() => {this.handleFormSubmit(this.props.riskname)}}>
                      Submit
                    </Button>
                    <Button variant="outlined" color="secondary" className={classes.button} onClick= {() => {this.handleFormRestore()}}>
                      Restore
                    </Button>

                </form>

            </div>
        )


        return (
            <div style={{height:'92%'}}>
                {inputForm}
            </div>
        );
    }
}

RecipeReviewCard.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RecipeReviewCard);


// WEBPACK FOOTER //
// ./src/components/Risks/RiskRegisterDetail.js